import { Dialog, DialogContent, Typography, Button, Box } from '@mui/material';
import './ArtRequestForm.scss';
interface Props {
  open: boolean;
  onClose: () => void;
}

export default function ArtFormSubmitted({ open, onClose }: Props) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      PaperProps={{
        sx: {
          width: '1865px',
          height: '1197px',
          margin: 'auto',
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)'
          // background: '#D9D9D9'
        }
      }}
    >
      <DialogContent
        sx={{
          padding: '0',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          height: '100%',
          minHeight: '500px'
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 4,
            textAlign: 'center',
            padding: '40px 20px'
          }}
        >
          <Typography
            variant="h5"
            sx={{
              color: '#000',
              fontFamily: '"Open Sans"',
              fontSize: '29px',
              fontStyle: 'normal',
              fontWeight: 400,
              lineHeight: 'normal',
              marginBottom: '20px'
            }}
          >
            Thank you for your submission. Your request is under review
          </Typography>

          <Button
            variant="contained"
            onClick={onClose}
            className="art-request-submit submit-close"
          >
            Close
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
